import { render, staticRenderFns } from "./PendenciesImagesModal.vue?vue&type=template&id=6d06a8bf"
import script from "./PendenciesImagesModal.vue?vue&type=script&lang=js"
export * from "./PendenciesImagesModal.vue?vue&type=script&lang=js"
import style0 from "./PendenciesImagesModal.vue?vue&type=style&index=0&id=6d06a8bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports